import React, { useState } from "react"
import { AccordionItem, MobileLink } from "."

export const StaticAccordion = () => {
  const [corporateOpen, setCorporateOpen] = useState(false)
  const [aboutOpen, setAboutOpen] = useState(false)

  return (
    <div>
      <AccordionItem
        title="Corporate"
        open={corporateOpen}
        onToggle={() => setCorporateOpen((current) => !current)}
      >
        <MobileLink link="/hire-graduates">Hire Graduates</MobileLink>
        <MobileLink link="/corporate-training">Corporate Training</MobileLink>
      </AccordionItem>
      <AccordionItem
        title="About"
        open={aboutOpen}
        onToggle={() => setAboutOpen((current) => !current)}
      >
        <MobileLink link="/tentang-kami">Tentang Kami</MobileLink>
        <MobileLink link="/alumni">Alumni</MobileLink>
      </AccordionItem>
    </div>
  )
}
